// extracted by mini-css-extract-plugin
export default {"mainFull":"Home_mainFull__YVgDm","main":"Home_main__tmjwB","connect":"Home_connect__jZMFE","weibo":"Home_weibo__rxnKT","weixin":"Home_weixin__NlnxR"};